import React from "react";
import { jsx } from "slate-hyperscript";
import {
    BlockHandler, ElementType, InlineHandler, StyleType,
} from "./base";

BlockHandler.register(ElementType.CODE_BLOCK, {
    nodeTypes: ["PRE"],

    toBlock: child => <pre className="bg-gray-100 p-2 border-1 rounded"><code>{child}</code></pre>,
    serialize: child => `<pre><code>${child}</code></pre>`,
    deserialize: children => jsx("element", { type: ElementType.CODE_BLOCK }, children),
});

InlineHandler.register(StyleType.CODE, {
    nodeTypes: ["CODE"],
    toBlock: child => <code className="bg-gray-100 p-2 border-1 rounded">{child}</code>,
    serialize: child => `<code>${child}</code>`,
    deserialize: current => jsx("text", { ...current, [StyleType.CODE]: Object.create(null) }),
});
